export const idContent = {
  introduction: {
    content: [
      "Sejak debutnya pada tahun 1996, seri Pokémon telah memikat hati para pemain di seluruh dunia dan menjadi salah satu merek hiburan paling populer. Generator Pokémon Acak kami dirancang untuk pelatih dari segala usia, baik yang ingin menemukan Pokémon baru, menyusun tim yang seimbang, atau sekadar menikmati kejutan dalam perjalanan Pokémon mereka.",
      "Apakah Anda seorang pemain berpengalaman yang mencari inspirasi untuk pertandingan berikutnya atau pemain kasual yang ingin memperluas Pokédex Anda, alat generator Pokémon acak ini akan memberikan cara yang menyenangkan dan interaktif untuk menjelajahi dunia Pokémon yang luas."
    ]
  },
  howToUse: {
    content: [
      "Menggunakan pemilih Pokémon acak kami sangat sederhana dan intuitif. Ikuti langkah-langkah ini untuk mulai membuat tim Pokémon sempurna Anda:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Pilih jumlah Pokémon: Tentukan berapa banyak Pokémon yang ingin Anda hasilkan (1-8)." },
          { type: "text", content: "Pilih tipe: Filter tipe Pokémon tertentu, seperti Api, Air, Listrik, dll., atau pilih \"Semua\" untuk menyertakan semua tipe." },
          { type: "text", content: "Pilih generasi: Pilih dari generasi pertama hingga kedelapan, atau pilih \"Semua\" untuk menyertakan Pokémon dari semua generasi." },
          { type: "text", content: "Atur kelangkaan: Tentukan tingkat kelangkaan Pokémon yang dihasilkan." },
          { type: "text", content: "Klik \"Hasilkan\": Setelah mengatur preferensi, klik tombol untuk menghasilkan Pokémon." },
          { type: "text", content: "Jelajahi hasil: Lihat informasi detail tentang setiap Pokémon, termasuk statistik dasar, kemampuan, tipe, dan banyak lagi!" }
        ]
      },
      "Anda dapat menyesuaikan parameter kapan saja dan mencoba beberapa kali untuk menemukan kombinasi Pokémon yang berbeda."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Sepenuhnya gratis: Generator Pokémon acak kami benar-benar gratis untuk digunakan, tanpa biaya tersembunyi atau persyaratan berlangganan." },
          { type: "text", content: "Pengalaman yang dapat disesuaikan: Sesuaikan pilihan acak Anda berdasarkan tipe, generasi, dan kelangkaan." },
          { type: "text", content: "Alat edukasi: Pelajari statistik dasar, kemampuan, dan tipe berbagai Pokémon." },
          { type: "text", content: "Asisten pembentuk tim: Buat tim yang seimbang dengan cepat untuk pertarungan kasual atau kompetitif." },
          { type: "text", content: "Pembuat tantangan: Buat tantangan permainan unik dengan membatasi diri pada Pokémon yang dihasilkan secara acak." },
          { type: "text", content: "Tanpa akun: Mulai menggunakan alat ini segera tanpa perlu mendaftar atau memberikan informasi pribadi." }
        ]
      }
    ]
  },
  history: {
    content: [
      "Seri Pokémon dimulai pada tahun 1996 ketika Satoshi Tajiri menciptakan game pertama untuk Nintendo Game Boy. Terinspirasi oleh hobi masa kecilnya mengoleksi serangga, konsepnya berkisar pada menangkap, melatih, dan bertarung dengan makhluk yang dikenal sebagai \"Pocket Monsters\" atau Pokémon.",
      "Tonggak penting dalam sejarah Pokémon meliputi:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Peluncuran game asli Pokémon Red dan Green di Jepang" },
          { type: "text", content: "1998: Rilis internasional Pokémon Red dan Blue" },
          { type: "text", content: "1999: Peluncuran global permainan kartu koleksi Pokémon" },
          { type: "text", content: "2000: Rilis Pokémon Gold dan Silver dengan penambahan 100 Pokémon baru" },
          { type: "text", content: "2016: Peluncuran Pokémon GO, membawa seri ke platform mobile" },
          { type: "text", content: "2019: Rilis Pokémon Sword dan Shield di Nintendo Switch" }
        ]
      },
      "Saat ini, dengan lebih dari 900 Pokémon yang berbeda melalui delapan generasi, seri ini telah berkembang mencakup video game, permainan kartu koleksi, serial anime, film, merchandise, dan aplikasi mobile, menjadi salah satu waralaba media paling menguntungkan sepanjang masa."
    ]
  },
  popularPokemon: {
    content: [
      "Dalam sejarah Pokémon, beberapa Pokémon telah menjadi simbol ikonik dari seri ini:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: Maskot tipe Listrik dari seri ini, terkenal dengan ekornya yang berbentuk petir dan pipi merahnya." },
          { type: "text", content: "Charizard: Pokémon tipe Api/Terbang favorit penggemar, terkenal dengan penampilan seperti naga dan kekuatannya." },
          { type: "text", content: "Mewtwo: Pokémon legendaris tipe Psikis yang diciptakan melalui manipulasi genetik dari Mew, terkenal dengan kekuatan luar biasanya." },
          { type: "text", content: "Eevee: Dicintai karena kemampuan uniknya untuk berevolusi menjadi berbagai bentuk, termasuk Vaporeon, Jolteon, dan Flareon." },
          { type: "text", content: "Gyarados: Pokémon tipe Air/Terbang yang kuat yang berevolusi dari Magikarp yang lemah." },
          { type: "text", content: "Lucario: Pokémon tipe Petarung/Baja, terkenal dengan kekuatan auranya dan popularitasnya dalam pertarungan kompetitif." },
          { type: "text", content: "Greninja: Pokémon ninja tipe Air/Gelap yang mendapatkan popularitas melalui serial anime." }
        ]
      },
      "Generator Pokémon acak kami memberi Anda kesempatan untuk menemukan spesies ikonik ini, serta banyak spesies lain yang sama menariknya namun kurang dikenal."
    ]
  },
  popularGames: {
    content: [
      "Seri game Pokémon telah merilis banyak judul populer di berbagai platform:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Red, Blue, dan Yellow: Game asli yang memulai legenda di Game Boy." },
          { type: "text", content: "Pokémon Gold, Silver, dan Crystal: Memperkenalkan wilayah Johto dan sistem siang-malam." },
          { type: "text", content: "Pokémon Ruby, Sapphire, dan Emerald: Memperluas dunia game dengan wilayah Hoenn dan pertarungan ganda." },
          { type: "text", content: "Pokémon Diamond, Pearl, dan Platinum: Membawa seri ke Nintendo DS dengan fitur online." },
          { type: "text", content: "Pokémon Black dan White: Memperkenalkan jajaran Pokémon yang sepenuhnya baru dengan penekanan pada cerita." },
          { type: "text", content: "Pokémon X dan Y: Memperkenalkan model 3D dan Mega Evolution." },
          { type: "text", content: "Pokémon Sun dan Moon: Memikirkan ulang sistem gym dengan Island trials." },
          { type: "text", content: "Pokémon GO: Game mobile augmented reality yang menjadi fenomena global." },
          { type: "text", content: "Pokémon Sword dan Shield: Membawa seri ke Nintendo Switch dengan konsep Wild Area." },
          { type: "text", content: "Pokémon Legends: Arceus: Upaya pertama seri dalam genre dunia terbuka." }
        ]
      },
      "Setiap game memperkenalkan mekanik dan Pokémon baru, memperluas dunia Pokémon yang dapat dijelajahi melalui generator Pokémon acak kami."
    ]
  },
  tradingContests: {
    content: [
      "Pertukaran Pokémon telah menjadi fitur fundamental dari seri ini sejak awal. Game asli dirilis berpasangan khusus untuk mendorong pertukaran Pokémon antar teman untuk melengkapi Pokédex. Elemen sosial ini membantu menyebarkan popularitas Pokémon dan tetap penting hingga hari ini.",
      "Aspek kunci dari pertukaran meliputi:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon eksklusif versi yang hanya tersedia melalui pertukaran" },
          { type: "text", content: "Beberapa Pokémon seperti Machamp dan Gengar hanya berevolusi melalui pertukaran" },
          { type: "text", content: "Global Trading System (GTS) dalam game modern memungkinkan pertukaran di seluruh dunia" },
          { type: "text", content: "Pertukaran Pokémon langka atau shiny sebagai simbol status" }
        ]
      },
      "Kontes Pokémon, yang diperkenalkan di generasi ketiga, menyediakan cara alternatif untuk berkompetisi di mana Pokémon bersaing berdasarkan penampilan, pertunjukan, dan pesona daripada kekuatan bertarung. Kontes ini meliputi:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Berbagai kategori kontes (Keren, Cantik, Imut, Pintar, Kuat)" },
          { type: "text", content: "Gerakan khusus yang dirancang untuk kontes" },
          { type: "text", content: "Mengelola kondisi Pokémon melalui Berry dan Poffin" },
          { type: "text", content: "Kompetisi multi-tahap dengan penilaian visual awal dan babak pertunjukan" }
        ]
      },
      "Generator Pokémon acak kami dapat membantu Anda menemukan Pokémon yang unggul dalam kontes atau menjadi mitra pertukaran yang berharga, menambahkan dimensi baru pada pengalaman Pokémon Anda."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Apakah generator Pokémon acak ini gratis?",
            answer: "Ya, alat kami sepenuhnya gratis untuk digunakan, tanpa biaya tersembunyi atau persyaratan berlangganan."
          },
          {
            type: "faq",
            question: "Seberapa akurat data Pokémon?",
            answer: "Semua data Pokémon berasal dari PokéAPI resmi, memastikan akurasi dan pembaruan tepat waktu."
          },
          {
            type: "faq",
            question: "Bisakah saya menghasilkan Pokémon dari generasi tertentu?",
            answer: "Ya, Anda dapat memilih generasi mana pun dari pertama hingga kedelapan, atau pilih \"Semua\" untuk menyertakan semua generasi."
          },
          {
            type: "faq",
            question: "Bagaimana filter kelangkaan bekerja?",
            answer: "Algoritma kami memberikan nilai kelangkaan 1-10 kepada setiap Pokémon berdasarkan status legendaris/mitis, pengalaman dasar, dan faktor lainnya."
          },
          {
            type: "faq",
            question: "Bisakah saya menyimpan atau mengekspor Pokémon yang dihasilkan?",
            answer: "Saat ini, Anda dapat mengambil tangkapan layar hasil. Kami sedang mempertimbangkan untuk menambahkan fitur simpan/ekspor dalam pembaruan mendatang."
          },
          {
            type: "faq",
            question: "Apakah generator Pokémon acak mendukung perangkat mobile?",
            answer: "Ya, generator kami sepenuhnya mendukung desain responsif dan dapat digunakan di smartphone, tablet, dan komputer."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Generator Pokémon Acak kami menawarkan kemungkinan tak terbatas bagi penggemar kasual dan pelatih berdedikasi. Baik Anda ingin menemukan favorit baru, membuat tim bertema, atau menantang diri sendiri dengan kombinasi tak terduga, alat kami menyediakan cara yang menyenangkan dan mendidik untuk menjelajahi dunia Pokémon yang luas.",
      "Kami terus bekerja untuk meningkatkan generator dengan fitur dan opsi baru. Cobalah hari ini dengan mengatur preferensi Anda dan mengklik 'Generate' untuk melihat Pokémon apa yang menunggu Anda!",
      "Bagikan hasil Anda dengan teman dan pelatih lain, dan beri tahu kami bagaimana Anda menggunakan Generator Pokémon Acak dalam perjalanan Pokémon Anda. Selamat menjelajah!"
    ]
  },
  whichPokemonIntro: {
    content: [
      "Pernahkah Anda bertanya-tanya Pokémon apa yang paling mirip dengan Anda? Alat \"Pokémon Apa yang Paling Mirip Denganku?\" kami menawarkan cara yang menyenangkan dan unik untuk menemukan padanan Pokémon Anda berdasarkan karakteristik fisik Anda.",
      "Fitur inovatif ini menganalisis tinggi dan berat badan Anda untuk mengidentifikasi Pokémon yang paling mendekati proporsi Anda. Apakah Anda setinggi Charizard atau sekompak Pikachu, algoritma kami menemukan kecocokan Pokémon sempurna Anda dengan ketepatan yang mengejutkan."
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "Menggunakan alat \"Pokémon Apa yang Paling Mirip Denganku?\" kami sangat sederhana dan hanya membutuhkan beberapa detik. Ikuti langkah-langkah sederhana ini untuk menemukan kecocokan Pokémon Anda:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Masukkan nama (atau nama panggilan) Anda ke dalam formulir yang disediakan." },
          { type: "text", content: "Masukkan tinggi Anda dalam sentimeter (cm)." },
          { type: "text", content: "Masukkan berat Anda dalam kilogram (kg)." },
          { type: "text", content: "Klik tombol \"Temukan Pokémon Saya\" untuk melihat hasil Anda." },
          { type: "text", content: "Lihat Pokémon yang cocok dengan Anda, termasuk nama, tipe, ukuran, berat, dan skor kemiripan." },
          { type: "text", content: "Bagikan hasil Anda di media sosial atau unduh sebagai gambar untuk ditunjukkan kepada teman-teman Anda!" }
        ]
      },
      "Skor kemiripan menunjukkan seberapa dekat proporsi Anda dengan proporsi Pokémon. Semakin tinggi persentasenya, semakin dekat kecocokannya!"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "Menemukan padanan Pokémon Anda menawarkan nilai lebih dari sekadar hiburan:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Metode Pembelajaran yang Menyenangkan: Temukan dan pelajari Pokémon baru yang sesuai dengan karakteristik fisik Anda." },
          { type: "text", content: "Perspektif Unik: Lihat diri Anda melalui lensa dunia Pokémon." },
          { type: "text", content: "Pemicu Percakapan: Bagikan hasil Anda dengan teman-teman dan bandingkan Pokémon mana yang cocok dengan masing-masing dari Anda." },
          { type: "text", content: "Inspirasi Cosplay: Temukan Pokémon yang secara alami cocok dengan tipe tubuh Anda untuk ide cosplay." },
          { type: "text", content: "Membangun Tim: Buat tim bertema dalam game Pokémon berdasarkan kemiripan fisik dengan Anda dan teman-teman Anda." }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Seberapa akurat algoritma pencocokan?",
            answer: "Algoritma kami menggunakan data ukuran dan berat Pokémon resmi dari PokéAPI dan menghitung kemiripan berdasarkan jarak Euclidean proporsional. Meskipun dirancang lebih untuk kesenangan daripada akurasi ilmiah, banyak pengguna menemukan kecocokan yang mengejutkan akurat!"
          },
          {
            type: "faq",
            question: "Mengapa alat ini tidak mempertimbangkan karakteristik fisik lainnya?",
            answer: "Saat ini, kami fokus pada tinggi dan berat badan demi kesederhanaan, dan karena ini adalah atribut fisik yang paling konsisten didokumentasikan di semua spesies Pokémon. Kami mungkin akan menambahkan lebih banyak atribut dalam pembaruan mendatang."
          },
          {
            type: "faq",
            question: "Bisakah saya cocok dengan Pokémon apa pun?",
            answer: "Saat ini, alat ini mencocokkan dengan 151 Pokémon asli (Generasi I) untuk mengoptimalkan kinerja. Kami berencana untuk memperluas ini di pembaruan mendatang untuk mencakup semua generasi."
          },
          {
            type: "faq",
            question: "Apakah data pribadi saya disimpan atau dibagikan?",
            answer: "Tidak, kami tidak menyimpan tinggi, berat, atau informasi pribadi lainnya yang Anda masukkan. Semua perhitungan dilakukan di browser Anda, dan tidak ada yang dikirim ke server kami."
          },
          {
            type: "faq",
            question: "Mengapa saya mendapatkan Pokémon yang berbeda dari teman saya dengan ukuran serupa?",
            answer: "Perbedaan kecil dalam rasio tinggi terhadap berat dapat menyebabkan kecocokan yang berbeda. Algoritma mempertimbangkan proporsi daripada nilai absolut."
          },
          {
            type: "faq",
            question: "Bisakah saya membagikan hasil saya di media sosial?",
            answer: "Ya! Anda dapat mengunduh hasil Anda sebagai gambar atau membagikannya langsung ke platform seperti Facebook dan Twitter menggunakan tombol yang disediakan."
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "Alat \"Pokémon Apa yang Paling Mirip Denganku?\" kami memberikan wawasan yang menyenangkan tentang bagaimana Anda mungkin ada di dunia Pokémon yang menakjubkan. Meskipun terutama dirancang untuk hiburan, banyak pengguna menemukan koneksi mengejutkan dengan kepribadian atau kemampuan Pokémon yang dicocokkan dengan mereka, melampaui kemiripan fisik belaka.",
      "Cobalah untuk sedikit mengubah input Anda untuk melihat bagaimana tinggi dan berat yang berbeda mempengaruhi kecocokan Anda, atau tantang teman dan keluarga untuk menemukan padanan Pokémon mereka. Anda mungkin terkejut dengan pasangan Pokémon yang dihasilkan!",
      "Entah Anda cocok dengan Pokémon Legendaris yang megah, Starter yang kuat, atau Pocket Monster yang kurang dihargai, rangkullah padanan Pokémon Anda dan sifat unik yang Anda bagikan. Lagi pula, di dunia Pokémon, setiap spesies memiliki kekuatan dan signifikansi khusus mereka sendiri."
    ]
  }
}; 